/* eslint-disable max-classes-per-file, class-methods-use-this */
import { timeDiff } from "common/utils/date";
import { reload } from "common/utils/browser";

const DEFAULT_INTERVAL = 1000;

class ProductCompositionCountdownTimeleft extends Error {
  constructor(message) {
    super(message);
    this.name = "ProductCompositionCountdownTimeleft";
  }
}

export class ProductCompositionCountdown {
  timerInterval = DEFAULT_INTERVAL;

  timeout = null;

  constructor(interval = DEFAULT_INTERVAL) {
    this.timerInterval = interval;
  }

  clear() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  update($el) {
    const { countdown: toDate } = $el.dataset;
    if (!toDate) return;

    const diff = timeDiff(new Date(toDate), new Date());
    if (!diff) return;

    if (diff.hours > 0 || diff.minutes > 0 || diff.seconds > 0) {
      $el.innerHTML = diff.text;
    } else if (diff.isNoTimeLeft) {
      throw new ProductCompositionCountdownTimeleft();
    }
  }

  runAll() {
    try {
      const $elements = document.querySelectorAll("[data-countdown]");
      [...$elements].forEach($el => this.update($el));
      this.timeout = setTimeout(() => this.runAll(), this.timerInterval);
    } catch (error) {
      if (error instanceof ProductCompositionCountdownTimeleft) {
        this.clear();
        reload();
      }
    }
  }

  setup() {
    this.clear();
    this.runAll();
  }
}

const init = () => new ProductCompositionCountdown().setup();

export default init;
